import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-period-dropdown',
    templateUrl: './period-dropdown.component.html',
    styleUrls: ['./period-dropdown.component.css'],
    standalone: false
})
export class PeriodDropdownComponent {
  @Input() periods: any[] = [];
  @Input() value: any;
  @Input() placeholder: string = 'Custom period';
  @Input() optionLabel: string = 'label';
  @Input() optionValue: string = 'value';
  @Input() disabled: boolean = false;
  @Input() styleClass: string = 'inputfield w-full';
  @Input() scrollHeight: string = '250px';

  @Output() valueChange = new EventEmitter<any>();

  onChange(event: any) {
    this.valueChange.emit(event.value);
  }
} 